<template>
  <SeriesContainer class="serie">
    <path
      v-if="strokeVisible"
      :d="paths.base"
      fill="none"
      :stroke="stroke(dataProps)"
      :stroke-width="strokeWidth"
      :stroke-dasharray="strokeDashedArray"
    />
  </SeriesContainer>
</template>

<script>
import { scaleQuantize } from 'd3-scale';
import { isNil, prop } from 'ramda';

import { SeriesContainer } from './areaChart.styles';

export default {
  components: { SeriesContainer },
  props: {
    x: Number,
    labelsScale: Function,
    yScale: Function,
    serie: String,
    serieIndex: Number,
    data: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] },
    xProp: String,
    fill: Function,
    stroke: Function,
    strokeWidth: Number,
    strokeVisible: Boolean,
    strokeDashedArray: { type: String, required: false },
    noDataStrokeVisible: Boolean,
    noDataStrokeWidth: Number,
    noDataStrokeDashedArray: String,
    handleMouseOver: Function,
    handleMouseOut: Function,
    handleClick: Function,
  },
  inject: ['cursorPoint'],
  data() {
    return {
      hoveredLabel: null,
    };
  },
  computed: {
    paths() {
      return this.data.reduce(
        (pathsData, item, index) => {
          const xId = item[this.xProp];
          const x = this.labelsScale(xId);

          const value = prop(this.serie, item);
          const hasValue = !isNil(value);
          const y = hasValue && this.yScale(value);

          const getLetter = ifTrue => (ifTrue ? 'L' : 'M');
          const baseLetter = getLetter(pathsData.hasPrevious);
          const dashedLetter = getLetter(!pathsData.hasPrevious && index);

          pathsData.hasPrevious = hasValue;

          if (hasValue) {
            pathsData.base += `${baseLetter}${x},${y}`;
            pathsData.dashed += `${dashedLetter}${x},${y}`;
          }

          return pathsData;
        },
        { base: '', dashed: '', hasPrevious: false }
      );
    },
    dataProps() {
      return {
        serie: this.serie,
        serieIndex: this.serieIndex,
        data: this.data,
        series: this.series,
      };
    },
    inverseLabelsScale() {
      const domain = this.labelsScale.domain();
      const range = this.labelsScale.range();
      return scaleQuantize()
        .domain(range)
        .range(domain);
    },
  },
  methods: {
    resetHoveredLabel() {
      this.$emit('leave', {
        id: `${this.serie}-${this.hoveredLabel}`,
      });
      this.hoveredLabel = null;
    },
    handleMouseMove(event) {
      const { clientX, clientY } = event;
      const { x } = this.cursorPoint(clientX, clientY);
      const hoveredLabel = this.inverseLabelsScale(x);

      const data = this.data.find(dataPoint => dataPoint[this.xProp] === hoveredLabel);

      if (this.hoveredLabel !== hoveredLabel) {
        if (this.hoveredLabel) {
          this.resetHoveredLabel();
        }

        this.$emit('enter', {
          id: `${this.serie}-${hoveredLabel}`,
          data,
          serie: this.serie,
          targetBox: {
            x: this.labelsScale(hoveredLabel),
            y: this.yScale(data[this.serie]),
            width: 1,
            height: 1,
          },
        });
      }

      this.hoveredLabel = hoveredLabel;
    },
    handleMouseLeave() {
      if (this.hoveredLabel) {
        this.resetHoveredLabel();
      }
    },
  },
};
</script>
